import React, { useState } from "react";
import ConnectPopup from "../ConnectPopup/ConnectPopup";
import MemberButton from "../MemberButton/MemberButton";
import { ConnectButton } from "@rainbow-me/rainbowkit";

const ConnectButtonComponent = ({ text, setUser, user }) => {
  const [open, setOpen] = useState(false);
  const [wallet, setWallet] = useState("");

  return (
    <div className="relative">
      {wallet.length ? (
        <div className="flex gap-[7px]">
          <MemberButton
            setWallet={setWallet}
            user={user}
            setUser={setUser}
          ></MemberButton>
        </div>
      ) : (
        <ConnectButton chainStatus={"icon"} />)}
       
   
      {open && (
        <ConnectPopup setOpen={setOpen} setWallet={setWallet}></ConnectPopup>
      )}
    </div>
  );
};

export default ConnectButtonComponent;
{ /*
<button
  onClick={() => setOpen((pre) => !pre)}
  className="nav-button-rounded "
>
  {text || "Connect"}
</button>*/ }